/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Form, Select } from 'antd';
import { useOpenDevTools } from '@/renderer/hooks/useOpenDevTools';
import { VERSION } from '@/renderer/config/setting';
// import { ProCard } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';
import YQIcon from '@/renderer/components/common/YQIcon';
import ProcessAction from './components/ProcessAction';
// import { useSearchParams } from 'react-router-dom';
// import { useEffect } from 'react';

function DashBoard() {
  const { handleOpenDevTools } = useOpenDevTools();
  const { i18n } = useTranslation();

  return (
    <>
      <div>
        {/* 下拉菜单可以切换语言 */}
        <Form>
          <Form.Item
            label={
              <YQIcon
                src="https://warp-pop-public.oss-cn-shanghai.aliyuncs.com/ai_recruitment_client_web/assets/i18n.png"
                width="22px"
                height="22px"
              />
            }
          >
            <Select
              value={i18n.language}
              onChange={(value) => i18n.changeLanguage(value)}
              style={{ width: 120 }}
              options={[
                { value: 'zh-CN', label: '中文' },
                { value: 'en', label: 'English' },
              ]}
            />
          </Form.Item>
        </Form>
        <div onClick={handleOpenDevTools}>v{VERSION}</div>
        <ProcessAction />
      </div>
      {/* TODO: 接入数据 */}
      {/* <ProCard style={{ marginBlockStart: 8 }} gutter={12}>
        <ProCard title="当日" colSpan={14} layout="center" bordered>
          <div className="flex w-full gap-1">
            <ProCard bordered>
              <div>
                <div>110</div>
                <div>已收集</div>
              </div>
            </ProCard>
            <ProCard bordered>
              <div>
                <div>110</div>
                <div>已筛选</div>
              </div>
            </ProCard>
            <ProCard bordered>
              <div>
                <div>110</div>
                <div>已通过</div>
              </div>
            </ProCard>
          </div>
        </ProCard>
        <ProCard title="当前" colSpan={10} layout="center" bordered>
          <div className="flex w-full gap-1">
            <ProCard bordered>
              <div>
                <div>110</div>
                <div>沟通中</div>
              </div>
            </ProCard>
            <ProCard bordered>
              <div>
                <div>110</div>
                <div>待预约</div>
              </div>
            </ProCard>
          </div>
        </ProCard>
      </ProCard> */}
      {/* TODO: 引入图表 https://echarts.apache.org/handbook/zh/get-started/ */}
      {/* TODO: 接入来自go客户端的数据 来源未定 ipc ? websocket ? */}
    </>
  );
}

export default DashBoard;
